import React, {FC, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import styles from './UserProfile.module.scss';
import TitleWrapper from './../TitleWrapper';
import InputTextField from './../InputTextField';
import CountrySelect from './../CountrySelect';
import PublishButton from './../PublishButton';
import AvatarDisplay from './../AvatarDisplay';
import {useSelector} from 'react-redux';
import {selectMediakitUser, setMediakitUser} from './../../features/stores/mediakitUser.slice';
import {store} from './../../app/store';
import {setDataChange} from './../../features/stores/changeData.slice';

const UserProfile: FC = () => {
    const {t, i18n} = useTranslation();
    const mediakitUser = useSelector(selectMediakitUser);
    const [showFollower, setShowFollower] = useState(mediakitUser.displayFollower);
    const setFollower = (value: any) => {
        setShowFollower(value);
        store.dispatch(setMediakitUser({...mediakitUser, displayFollower: value}));
        store.dispatch(setDataChange(true));
    };
    useEffect(() => {
        setShowFollower(mediakitUser.displayFollower);
    }, [mediakitUser?.displayFollower]);
    return (
        <div>
            <TitleWrapper title={t('profile')} subtitle={t('your_public_profile')} />
            <div className={styles.main}>
                <div className={styles.avatar_container}>
                    <AvatarDisplay />
                </div>
                <div className={styles.input_container}>
                    <div className={styles.label}>{t('display_name')}</div>
                    <InputTextField value={mediakitUser.fullname as string} onChange={(e: any)=>{
                        store.dispatch(setMediakitUser({...mediakitUser, fullname: e.target.value}));
                        store.dispatch(setDataChange(true));
                    }} />
                </div>
                <div className={styles.input_container}>
                    <div className={styles.label}>{t('country')}</div>
                    <CountrySelect />
                </div>
                <div className={styles.input_container}>
                    <div className={styles.label}>{t('bio')}</div>
                    <textarea value={mediakitUser.bio as string} className={styles.bio_input} onChange={(e: any)=>{
                        store.dispatch(setMediakitUser({...mediakitUser, bio: e.target.value}));
                        store.dispatch(setDataChange(true));
                    }} />
                </div>
                <div className={styles.input_container}>
                    <div className={styles.label}>{t('show_follower_count')}</div>
                    <div className={styles.tabs}>
                        <button className={showFollower ? styles.tabs__selected : ''} onClick={() => setFollower(true)}>{t('yes')}</button>
                        <button className={!showFollower ? styles.tabs__selected : ''} onClick={() => setFollower(false)}>{t('no')}</button>
                    </div>
                </div>
                <div className={styles.publish_conatiner}>
                    <PublishButton />
                </div>
            </div>
        </div>
    );
};

export default UserProfile;
